import { ReminderLogsTable } from "components";

const ReminderLogs = () => {
    return (
        <ReminderLogsTable />
    );
}

export default ReminderLogs;
